export const categoryBoxTypes = {
    default: 'default',
    linear: 'linear',
};